/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/forms';
import * as i2 from '@angular/common';
import * as i3 from '../../../ui/settings/sim-control.component';
const styles_SimControlComponent:any[] = ([] as any[]);
export const RenderType_SimControlComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_SimControlComponent,data:{}});
function View_SimControlComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),7,'input',[['maxlength',
      '7'],['style','display: inline; width: 80px;'],['title','maximal time'],['type',
      'text']],[[1,'maxlength',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',
      (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
      [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
          (null as any)]],[[(null as any),'ngModelChange'],[(null as any),'input'],
      [(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),'compositionend']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i0.ɵnov(_v,1).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i0.ɵnov(_v,1)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i0.ɵnov(_v,1)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_4:any = ((<any>(_co.maxTimeUserInput = $event)) !== false);
          ad = (pd_4 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i1.DefaultValueAccessor,
      [i0.Renderer2,i0.ElementRef,[2,i1.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),
      i0.ɵdid(540672,(null as any),0,i1.MaxLengthValidator,([] as any[]),{maxlength:[0,
          'maxlength']},(null as any)),i0.ɵprd(1024,(null as any),i1.NG_VALIDATORS,
          (p0_0:any) => {
            return [p0_0];
          },[i1.MaxLengthValidator]),i0.ɵprd(1024,(null as any),i1.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i1.DefaultValueAccessor]),i0.ɵdid(671744,(null as any),0,i1.NgModel,[[8,
          (null as any)],[2,i1.NG_VALIDATORS],[8,(null as any)],[2,i1.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),
          i1.NgControl,(null as any),[i1.NgModel]),i0.ɵdid(16384,(null as any),0,i1.NgControlStatus,
          [i1.NgControl],(null as any),(null as any))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_8:any = '7';
    _ck(_v,2,0,currVal_8);
    const currVal_9:any = _co.maxTimeUserInput;
    _ck(_v,5,0,currVal_9);
  },(_ck,_v) => {
    const currVal_0:any = (i0.ɵnov(_v,2).maxlength? i0.ɵnov(_v,2).maxlength: (null as any));
    const currVal_1:any = i0.ɵnov(_v,7).ngClassUntouched;
    const currVal_2:any = i0.ɵnov(_v,7).ngClassTouched;
    const currVal_3:any = i0.ɵnov(_v,7).ngClassPristine;
    const currVal_4:any = i0.ɵnov(_v,7).ngClassDirty;
    const currVal_5:any = i0.ɵnov(_v,7).ngClassValid;
    const currVal_6:any = i0.ɵnov(_v,7).ngClassInvalid;
    const currVal_7:any = i0.ɵnov(_v,7).ngClassPending;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7);
  });
}
function View_SimControlComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),4,'div',[['class',
      'settings-left']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n		'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          1,'button',[['class','button']],(null as any),[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.onDoStepsClick()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),[' Do steps '])),
      (_l()(),i0.ɵted((null as any),['\n	']))],(null as any),(null as any));
}
function View_SimControlComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),3,'option',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),i0.ɵdid(147456,
      (null as any),0,i1.NgSelectOption,[i0.ElementRef,i0.Renderer2,[2,i1.SelectControlValueAccessor]],
      {ngValue:[0,'ngValue']},(null as any)),i0.ɵdid(147456,(null as any),0,i1.ɵq,
      [i0.ElementRef,i0.Renderer2,[8,(null as any)]],{ngValue:[0,'ngValue']},(null as any)),
      (_l()(),i0.ɵted((null as any),['','']))],(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit;
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = _v.context.$implicit;
    _ck(_v,2,0,currVal_1);
  },(_ck,_v) => {
    const currVal_2:any = _v.context.$implicit;
    _ck(_v,3,0,currVal_2);
  });
}
function View_SimControlComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),12,'div',[['class',
      'settings-right']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n		'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          9,'select',[['class','select'],['title','number of steps']],[[2,'ng-untouched',
              (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
              [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
                  (null as any)],[2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],
              [(null as any),'change'],[(null as any),'blur']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('change' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,3).onChange($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,3).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_2:any = ((<any>(_co.numSteps = $event)) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i1.SelectControlValueAccessor,
          [i0.Renderer2,i0.ElementRef],(null as any),(null as any)),i0.ɵprd(1024,(null as any),
          i1.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i1.SelectControlValueAccessor]),i0.ɵdid(671744,(null as any),0,i1.NgModel,
          [[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i1.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),
          i1.NgControl,(null as any),[i1.NgModel]),i0.ɵdid(16384,(null as any),0,i1.NgControlStatus,
          [i1.NgControl],(null as any),(null as any)),(_l()(),i0.ɵted((null as any),
          ['\n			'])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_SimControlComponent_4)),i0.ɵdid(802816,(null as any),0,i2.NgForOf,[i0.ViewContainerRef,
          i0.TemplateRef,i0.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),
      (_l()(),i0.ɵted((null as any),['\n		'])),(_l()(),i0.ɵted((null as any),['\n		step(s)\n	']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_7:any = _co.numSteps;
        _ck(_v,5,0,currVal_7);
        const currVal_8:any = _co.stepValues;
        _ck(_v,10,0,currVal_8);
      },(_ck,_v) => {
        const currVal_0:any = i0.ɵnov(_v,7).ngClassUntouched;
        const currVal_1:any = i0.ɵnov(_v,7).ngClassTouched;
        const currVal_2:any = i0.ɵnov(_v,7).ngClassPristine;
        const currVal_3:any = i0.ɵnov(_v,7).ngClassDirty;
        const currVal_4:any = i0.ɵnov(_v,7).ngClassValid;
        const currVal_5:any = i0.ɵnov(_v,7).ngClassInvalid;
        const currVal_6:any = i0.ɵnov(_v,7).ngClassPending;
        _ck(_v,2,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
      });
}
function View_SimControlComponent_5(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),4,'div',[['class',
      'settings-left']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n		'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          1,'button',[['class','button']],(null as any),[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.onResetClick()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),[' Reset '])),
      (_l()(),i0.ɵted((null as any),['\n	']))],(null as any),(null as any));
}
function View_SimControlComponent_7(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),3,'option',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),i0.ɵdid(147456,
      (null as any),0,i1.NgSelectOption,[i0.ElementRef,i0.Renderer2,[2,i1.SelectControlValueAccessor]],
      {ngValue:[0,'ngValue']},(null as any)),i0.ɵdid(147456,(null as any),0,i1.ɵq,
      [i0.ElementRef,i0.Renderer2,[8,(null as any)]],{ngValue:[0,'ngValue']},(null as any)),
      (_l()(),i0.ɵted((null as any),['','']))],(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit;
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = _v.context.$implicit;
    _ck(_v,2,0,currVal_1);
  },(_ck,_v) => {
    const currVal_2:any = _v.context.$implicit;
    _ck(_v,3,0,currVal_2);
  });
}
function View_SimControlComponent_6(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),12,'div',[['class',
      'settings-right']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n		'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          9,'select',[['class','select'],['title','number of particles']],[[2,'ng-untouched',
              (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
              [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
                  (null as any)],[2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],
              [(null as any),'change'],[(null as any),'blur']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('change' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,3).onChange($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,3).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_2:any = ((<any>(_co.numParticles = $event)) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i1.SelectControlValueAccessor,
          [i0.Renderer2,i0.ElementRef],(null as any),(null as any)),i0.ɵprd(1024,(null as any),
          i1.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i1.SelectControlValueAccessor]),i0.ɵdid(671744,(null as any),0,i1.NgModel,
          [[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i1.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),
          i1.NgControl,(null as any),[i1.NgModel]),i0.ɵdid(16384,(null as any),0,i1.NgControlStatus,
          [i1.NgControl],(null as any),(null as any)),(_l()(),i0.ɵted((null as any),
          ['\n			'])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_SimControlComponent_7)),i0.ɵdid(802816,(null as any),0,i2.NgForOf,[i0.ViewContainerRef,
          i0.TemplateRef,i0.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),
      (_l()(),i0.ɵted((null as any),['\n		'])),(_l()(),i0.ɵted((null as any),['\n		particles\n	']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_7:any = _co.numParticles;
        _ck(_v,5,0,currVal_7);
        const currVal_8:any = _co.particleValues;
        _ck(_v,10,0,currVal_8);
      },(_ck,_v) => {
        const currVal_0:any = i0.ɵnov(_v,7).ngClassUntouched;
        const currVal_1:any = i0.ɵnov(_v,7).ngClassTouched;
        const currVal_2:any = i0.ɵnov(_v,7).ngClassPristine;
        const currVal_3:any = i0.ɵnov(_v,7).ngClassDirty;
        const currVal_4:any = i0.ɵnov(_v,7).ngClassValid;
        const currVal_5:any = i0.ɵnov(_v,7).ngClassInvalid;
        const currVal_6:any = i0.ɵnov(_v,7).ngClassPending;
        _ck(_v,2,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
      });
}
export function View_SimControlComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),50,'div',[['class',
      'settings-block']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n	'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          1,'h6',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['Simulation control'])),(_l()(),
          i0.ɵted((null as any),['\n\n	'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          1,'div',[['class','settings-left']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n		Simulation time:\n	'])),
      (_l()(),i0.ɵted((null as any),['\n	'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          1,'div',[['class','settings-right']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n		','\n		',
          '\n		seconds\n	'])),(_l()(),i0.ɵted((null as any),['\n	'])),(_l()(),i0.ɵeld(0,
          (null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          ['\n\n	'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),4,'div',[['class',
          'settings-left']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['\n		'])),(_l()(),i0.ɵeld(0,
          (null as any),(null as any),1,'button',[['class','button']],(null as any),
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i3.SimControlComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.onStartStopClick()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),[' ',' '])),
      (_l()(),i0.ɵted((null as any),['\n	'])),(_l()(),i0.ɵted((null as any),['\n	'])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),14,'div',[['class','settings-right']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n		'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          8,'label',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['\n			'])),(_l()(),i0.ɵeld(0,
          (null as any),(null as any),5,'input',[['class','checkbox'],['type','checkbox']],
          [[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
              'ngModelChange'],[(null as any),'change'],[(null as any),'blur']],(_v,
              en,$event) => {
            var ad:boolean = true;
            var _co:i3.SimControlComponent = _v.component;
            if (('change' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,24).onChange($event.target.checked)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,24).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_2:any = ((<any>(_co.maxTimeEnabled = $event)) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i1.CheckboxControlValueAccessor,
          [i0.Renderer2,i0.ElementRef],(null as any),(null as any)),i0.ɵprd(1024,(null as any),
          i1.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i1.CheckboxControlValueAccessor]),i0.ɵdid(671744,(null as any),0,i1.NgModel,
          [[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i1.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),
          i1.NgControl,(null as any),[i1.NgModel]),i0.ɵdid(16384,(null as any),0,i1.NgControlStatus,
          [i1.NgControl],(null as any),(null as any)),(_l()(),i0.ɵted((null as any),
          ['\n			','\n		'])),(_l()(),i0.ɵted((null as any),['\n		'])),(_l()(),i0.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_SimControlComponent_1)),
      i0.ɵdid(16384,(null as any),0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n	'])),(_l()(),
          i0.ɵted((null as any),['\n	'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['\n\n	'])),(_l()(),i0.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_SimControlComponent_2)),
      i0.ɵdid(16384,(null as any),0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n	'])),(_l()(),
          i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SimControlComponent_3)),
      i0.ɵdid(16384,(null as any),0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n	'])),(_l()(),
          i0.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),
              (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          ['\n\n	'])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_SimControlComponent_5)),i0.ɵdid(16384,(null as any),0,i2.NgIf,[i0.ViewContainerRef,
          i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),
          ['\n	'])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_SimControlComponent_6)),i0.ɵdid(16384,(null as any),0,i2.NgIf,[i0.ViewContainerRef,
          i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),
          ['\n'])),(_l()(),i0.ɵted((null as any),['\n\n']))],(_ck,_v) => {
    var _co:i3.SimControlComponent = _v.component;
    const currVal_10:any = _co.maxTimeEnabled;
    _ck(_v,26,0,currVal_10);
    const currVal_12:any = _co.maxTimeEnabled;
    _ck(_v,32,0,currVal_12);
    const currVal_13:boolean = !_co.isRunning;
    _ck(_v,38,0,currVal_13);
    const currVal_14:boolean = !_co.isRunning;
    _ck(_v,41,0,currVal_14);
    const currVal_15:boolean = !_co.isRunning;
    _ck(_v,46,0,currVal_15);
    const currVal_16:boolean = !_co.isRunning;
    _ck(_v,49,0,currVal_16);
  },(_ck,_v) => {
    var _co:i3.SimControlComponent = _v.component;
    const currVal_0:any = _co.totalTime.toFixed(4);
    const currVal_1:any = ((_co.maxTimeEnabled && (_co.parsedMaxTime > 0))? (' of ' + _co.parsedMaxTime): '');
    _ck(_v,9,0,currVal_0,currVal_1);
    const currVal_2:any = (_co.isRunning? 'Stop': 'Start');
    _ck(_v,16,0,currVal_2);
    const currVal_3:any = i0.ɵnov(_v,28).ngClassUntouched;
    const currVal_4:any = i0.ɵnov(_v,28).ngClassTouched;
    const currVal_5:any = i0.ɵnov(_v,28).ngClassPristine;
    const currVal_6:any = i0.ɵnov(_v,28).ngClassDirty;
    const currVal_7:any = i0.ɵnov(_v,28).ngClassValid;
    const currVal_8:any = i0.ɵnov(_v,28).ngClassInvalid;
    const currVal_9:any = i0.ɵnov(_v,28).ngClassPending;
    _ck(_v,23,0,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9);
    const currVal_11:any = (_co.maxTimeEnabled? 'Run until:': 'Set maximal time');
    _ck(_v,29,0,currVal_11);
  });
}
export function View_SimControlComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'websph-settings-sim-control',
      ([] as any[]),(null as any),(null as any),(null as any),View_SimControlComponent_0,
      RenderType_SimControlComponent)),i0.ɵdid(49152,(null as any),0,i3.SimControlComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const SimControlComponentNgFactory:i0.ComponentFactory<i3.SimControlComponent> = i0.ɵccf('websph-settings-sim-control',
    i3.SimControlComponent,View_SimControlComponent_Host_0,{},{maxTimeNotify:'maxTimeNotify',
        doStepsNotify:'doStepsNotify',resetNotify:'resetNotify',startNotify:'startNotify',
        stopNotify:'stopNotify'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// D:/[Projects]/WebSPH.gits/WebSPH.git/src/$$_gendir/ui/settings/sim-control.component.ngfactory.ts